module.exports = __webpack_public_path__ + "static/media/5.996632d7.jpg";